<ul class="list-group">
  @for (patient of patients; track patient) {
    <li
      (click)="onPatientClick(patient)"
      (keydown.enter)="onPatientClick(patient)"
      tabindex="0"
      class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
      >
      <span>
        <strong>{{ patient.fullName }}</strong> <small>{{ patient.dob | date: 'M/dd/yyyy' }}</small>
      </span>
      <span> {{ patient.gender | gender }} </span>
    </li>
  }
</ul>
